import Mtop from '@ali/lib-mtop'

export const getPanos = token => {
  return Mtop.request({
    api: 'mtop.taobao.aplatform.weakGet',
    v: '1.0',
    ecode: 0,
    valueType: 'string',
    dataType: 'json',
    data: {
      bizType: 'scenego_api.clientApi.queryPanoInfo',
      bizParam: JSON.stringify({
        token
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/Api/index.js